// extracted by mini-css-extract-plugin
module.exports = {"Map":"map-module--Map--2vkum"};